<div class="my-3 my-md-5">
    <div class="container-fluid px-4">
            <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row filter_row">
                        <div class="col-sm-2 mt-2"><input class="form-control" [(ngModel)]="search" type="text" (keyup)="loadData(0,perpage)" placeholder="Search" /></div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Bds" (selectionChange)="loadData(0,perpage)" [(ngModel)]="bd" (click)="setSearchValue('lead_owner')">
                                <input class="mySearchInput"
                                #ownerSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_owner')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="ownerSearch">
                                <mat-option >All</mat-option>
                                <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Circle" (selectionChange)="loadData(0,perpage)" [(ngModel)]="circle">
                                <mat-option >All</mat-option>
                                <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Doctor" (selectionChange)="loadData(0,perpage)" [(ngModel)]="doctor" (click)="setSearchValue('doctor')">
                                <input class="mySearchInput"
                                #doctorSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'doctor')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="doctorSearch">
                                <mat-option >All</mat-option>
                                <mat-option [value]="odoctor.id" *ngFor="let odoctor of doctors">{{odoctor.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Hospital" (selectionChange)="loadData(0,perpage)" [(ngModel)]="hospital" (click)="setSearchValue('hospital')">
                                <input class="mySearchInput"
                                #hospitalSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'hospital')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="hospitalSearch">
                                <mat-option >All</mat-option>
                                <mat-option [value]="ohospital.id" *ngFor="let ohospital of hospitals">{{ohospital.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Treatment" (selectionChange)="loadData(0,perpage)" [(ngModel)]="treatment" (click)="setSearchValue('treatment')">
                                <input class="mySearchInput"
                                #treatmentSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="treatmentSearch">
                                <mat-option >All</mat-option>
                                <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatments">{{ltreatment.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Status" (selectionChange)="loadData(0,perpage)" [(ngModel)]="status">
                                <mat-option >All</mat-option>
                                <mat-option value="0">Active</mat-option>
                                <mat-option value="1">Completed</mat-option>
                                <mat-option  *ngIf="myrole!='5'" value="3">Cancelled</mat-option>
                                <mat-option value="2" *ngIf="myrole=='1'">Deleted</mat-option>

                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole!='2' && myrole!='16'">
                            <mat-select  placeholder="Lead Source" (selectionChange)="loadData(0,perpage)" [(ngModel)]="lead_source" multiple>
                                <mat-option value="{{lsources.id}}" *ngFor="let lsources of lead_sources">{{lsources.source_name}}</mat-option>

                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Payment Mode" (selectionChange)="loadData(0,perpage)" [(ngModel)]="payment_mode">
                                <mat-option >All</mat-option>
                                <mat-option *ngIf="myrole!='5'" value="1">Cash</mat-option>
                                <mat-option value="2">Cashless</mat-option>
                                <mat-option value="3">Reimbursement</mat-option>
                                <mat-option *ngIf="myrole!='5'" value="4">EMI</mat-option>
                            </mat-select>
                        </div>

                        <div class="col-sm-3 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter surgery date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>
                        </div>
                        <div class="col-sm-3 mt-2" >
                            <mat-form-field appearance="fill">
                                <mat-label>Enter Discharge date range</mat-label>
                                <mat-date-range-input [rangePicker]="dischargepicker">
                                    <input matStartDate #dischargedateRangeStart placeholder="Start date">
                                    <input matEndDate #dischargedateRangeEnd placeholder="End date" (dateChange)="dischargedateRangeChange(dischargedateRangeStart, dischargedateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="dischargepicker"></mat-datepicker-toggle>
                                <mat-date-range-picker #dischargepicker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="dischargeclearDate()">clear</mat-icon>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || myrole=='3'">
                            <mat-select (selectionChange)="checkIn()" placeholder="Show Selected Columns" multiple [(ngModel)]="columnDrp">
                                <mat-option [value]="0">Appointment Id</mat-option>
                                <mat-option [value]="1">Patient Name</mat-option>
                                <mat-option [value]="2">Patient Mobile</mat-option>
                                <mat-option [value]="3">Status</mat-option>
                                <mat-option [value]="4">Circle</mat-option>
                                <mat-option [value]="5">Treatment Name</mat-option>
                                <mat-option [value]="6">Lead Owner</mat-option>
                                <mat-option [value]="7">Hospital Name</mat-option>
                                <mat-option [value]="8">Doctor Name</mat-option>
                                <mat-option [value]="9">Mode of Payment</mat-option>
                                <mat-option [value]="10">Lead Created Time</mat-option>
                                <mat-option [value]="11">Surgery Date</mat-option>
                                <mat-option [value]="12">Billed Amount</mat-option>
                                <mat-option [value]="13">MOU Discount</mat-option>
                                <mat-option [value]="14">Copay</mat-option>
                                <mat-option [value]="15">Non Consumable</mat-option>
                                <mat-option [value]="16">Prop Ded</mat-option>
                                <mat-option [value]="17">Insurance Paid</mat-option>
                                <mat-option [value]="18">Patient Paid</mat-option>
                                <mat-option [value]="19">Settlement Amount</mat-option>
                                <mat-option [value]="20">Doctor Share</mat-option>
                                <mat-option [value]="21">Hospital Share</mat-option>
                                <mat-option [value]="22">Lab Charges</mat-option>
                                <mat-option [value]="23">Medicine Charges</mat-option>
                                <mat-option [value]="24">OT Charges</mat-option>
                                <mat-option [value]="25">Other Charges</mat-option>
                                <mat-option [value]="26">Consuambles</mat-option>
                                <mat-option [value]="27">Lapset Vendor</mat-option>
                                <mat-option [value]="28">Anaesthetist</mat-option>
                                <mat-option [value]="29">Glamyo Share</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-3" *ngIf="myrole=='1' || myrole=='3'">
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" (change)="setConsumables()" [(ngModel)]="consumablesChk">
                                <span class="custom-control-label">Show Consumables Only</span>
                            </label>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>

        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-5 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading" (click)="loadData(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>

                    <button type="button" *ngIf="myrole=='1' || myrole=='8' || myrole=='9' || myrole=='14'" class="btn btn-success ml-2" [disabled]="loading" (click)="exportTransactionList()"><i class="fa fa-file-excel"></i> Export List</button>
                </div>
                <div class="col-sm-7">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator>
                </div>
            </div>

            <div class="text-center" *ngIf="loading"><i class="fa fa-spin fa-spinner fa-2x"></i></div>
            <hot-table [fixedColumnsLeft]="3" [hiddenColumns]="hideColumn" [hotId]="id" [colHeaders]="true" [columnSorting]="false" width="100%" [height]="600" [rowHeaders]="true" [data]="IpdData" licenseKey="non-commercial-and-evaluation" [beforeChange]="onBeforeChange" [autoWrapRow]="false" [autoWrapCol]="false" [afterOnCellMouseDown]="afterOnCellMouseDownCallBack">
                <hot-column data="patient_id" [readOnly]="true" title="Appointment Id"></hot-column>
                <hot-column data="glamyoAppointmentId" [readOnly]="true" title="Glamyo Appointment Id"></hot-column>
                <hot-column data="patient" [readOnly]="true" title="Patient Name"></hot-column>
                <hot-column data="phone" [readOnly]="true" title="Patient Mobile"></hot-column>
                <hot-column data="status" [readOnly]="true" title="Status"></hot-column>
                <hot-column data="circle_name" [readOnly]="true" title="Circle"></hot-column>
                <hot-column data="lead_source_name" [readOnly]="true" title="Source Name"></hot-column>
                <hot-column data="rtype" [readOnly]="true" title="Refferal Type"></hot-column>
                <hot-column data="referral_person_name" [readOnly]="true" title="Refferal Person Name"></hot-column>
                <hot-column data="referral_person_number" [readOnly]="true" title="Refferal Person Mobile"></hot-column>
                <hot-column data="hospitalCityName" [readOnly]="true" title="City Name"></hot-column>
                <hot-column data="treatment_name" [readOnly]="true" title="Treatment Name"></hot-column>
                <hot-column data="treatment_categoriesName" [readOnly]="true" title="Treatment Catergory"></hot-column>
                <hot-column data="bd_name" [readOnly]="true" title="Lead Owner"></hot-column>
                <hot-column data="hospital_name" [readOnly]="true" title="Hospital Name"></hot-column>
                <hot-column data="doctor_name" [readOnly]="true" title="Doctor Name"></hot-column>
                <hot-column data="payment_mode" [readOnly]="true" title="Mode of Payment"></hot-column>
                <hot-column data="lead_time" [readOnly]="true" title="Lead Created Time"></hot-column>
                <hot-column data="arrival_time" [readOnly]="true" title="Admission Time"></hot-column>
                <hot-column data="surgery_date" [readOnly]="true" dateFormat='DD/MM/YYYY' title="Surgery Date"></hot-column>

                <hot-column data="discharge_date" [readOnly]="adminInsuranceRole" type="date" allowEmpty="true" dateFormat='DD/MM/YYYY' title="Discharge Date"></hot-column>

                <hot-column data="billed_amt" type="numeric" [readOnly]="adminInsuranceRole" title="Billed Amount"></hot-column>
                <hot-column data="mou_amt" [readOnly]="adminInsuranceRole" title="MOU Discount"></hot-column>
                <hot-column data="copay_amt" [readOnly]="adminInsuranceRole" title="Copay"></hot-column>
                <hot-column data="non_consuamble_amt"  [readOnly]="adminInsuranceRole" title="Non Consumable"></hot-column>
                <hot-column data="prop_mou_amt" [readOnly]="adminInsuranceRole" title="Prop Ded"></hot-column>
                <hot-column data="insurance_amt" [readOnly]="adminInsuranceRole" title="Insurance Paid"></hot-column>
                <hot-column data="paitent_paid_amt" [readOnly]="adminInsuranceRole" title="Patient Paid"></hot-column>
                <hot-column data="settled_amt" [readOnly]="adminInsuranceRole" title="Settlement Amount"></hot-column>
                <hot-column data="doctor_share" [readOnly]="adminRole" title="Doctor Share"></hot-column>
                <hot-column *ngIf="myrole!='5'" data="hospital_share" [readOnly]="adminRole" title="Hospital Share"></hot-column>

                <hot-column *ngIf="myrole!='5'" data="lab_charges" [readOnly]="adminRole" title="Lab Charges"></hot-column>
                <hot-column *ngIf="myrole!='5'" data="medicine_charges" [readOnly]="adminRole" title="Medicine Charges"></hot-column>
                <hot-column *ngIf="myrole!='5'" data="ot_charges" [readOnly]="adminRole" title="OT Charges"></hot-column>
                <hot-column *ngIf="myrole!='5'" data="others_charges" [readOnly]="adminRole" title="Other Charges"></hot-column>

                <hot-column *ngIf="myrole!='5'" width="300px" data="consuambleData" [readOnly]="true"  renderer="html" title="Consuambles"></hot-column>
                <hot-column *ngIf="myrole!='5'" width="300px" data="lapsetData" [readOnly]="true"  renderer="html" title="Lapset Vendor"></hot-column>
                <hot-column *ngIf="myrole!='5'" width="300px" data="anaesthetistData" [readOnly]="true"  renderer="html" title="Anaesthetist"></hot-column>

                <hot-column *ngIf="myrole!='5'" data="glamyo_share"  [readOnly]="adminRole" title="Glamyo Share"></hot-column>
                <hot-column renderer="html" width="100" *ngIf="(myrole=='1')" data="ipd_transaction_history" [readOnly]="true" title="View History"></hot-column>
                <!-- <hot-column *ngIf="myrole!='5'" data="glamyo_share" renderer="html"  [readOnly]="adminRole" title="Glamyo Share"></hot-column> -->
            </hot-table>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>


<!-- The Modal to view Billed Amount History -->
<div class="modal fade" id="BilledModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h3 class="modal-title billedTitle">History</h3>
          <button type="button" class="close" (click)="hideModal()"></button>
        </div>

        <!-- Modal body -->
        <div class="col-sm-12">
            <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                <tbody>
                    <tr *ngFor="let ipdbilled of ipdHistoryDetail">
                        <td>
                            <div [innerHTML]="ipdbilled.message | safe:'html'"></div>
                            <div class="small text-muted">
                                <i class="fas fa-clock"></i> {{ipdbilled.created_at*1000|date:'d MMM, yyyy H:mm aa'}}
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="!ipdHistoryDetail.length && billedloaded">
                        <td>No history found</td>
                    </tr>
                    <tr *ngIf="billedloading">
                        <td><i class="fa fa-spin fa-spinner"></i></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModal()">Close</button>
        </div>
      </div>
    </div>
</div>